export default "__VITE_ASSET__BbMfG3p2__"